import CultureTabImage from "../../Assets/Images/culture-tabImage.png";
import CultureTabTopGraphic from "../../Assets/Images/culture-tabtop-Graphic.png";
import CultureTabBottomGraphic from "../../Assets/Images/culture-tabBottom-Graphic.png";

const CultureCapsuleImageVertical = () => {
  return (
    <>
      <div className="relative sm:aspect-[5/4] lg:aspect-[3/4] w-full">
        <div className=" inset-0 middivimg">
          <div className="relative flex justify-center">
            <img
              src={CultureTabImage}
              alt="Smiling man"
              className="w-full z-[2] animate__animated animate__fadeIn"
            />
            <img
              src={CultureTabTopGraphic}
              alt=""
              className="w-full absolute mix-blend-normal top-0 animate__animated animate__fadeInDown z-[1]"
            />
            <img
              src={CultureTabBottomGraphic}
              alt=""
              className="w-full absolute mix-blend-normal top-0 animate__animated animate__fadeInUp"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CultureCapsuleImageVertical;
